// extracted by mini-css-extract-plugin
module.exports = {"header":"AddProvisionModal_header_1chej","wrapper":"AddProvisionModal_wrapper_3RAcu"};